var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20C14.2891 20 12.5 18.2109 12.5 16C12.5 13.7891 14.2891 12 16.5 12C18.7109 12 20.5 13.7891 20.5 16C20.5 18.2109 18.7109 20 16.5 20ZM16.5 14.1818C15.4964 14.1818 14.6818 14.9964 14.6818 16C14.6818 17.0036 15.4964 17.8182 16.5 17.8182C17.5036 17.8182 18.3182 17.0036 18.3182 16C18.3182 14.9964 17.5036 14.1818 16.5 14.1818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.1818C15.4964 14.1818 14.6818 14.9964 14.6818 16C14.6818 17.0036 15.4964 17.8182 16.5 17.8182C17.5036 17.8182 18.3182 17.0036 18.3182 16C18.3182 14.9964 17.5036 14.1818 16.5 14.1818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep);
export default __webpack_public_path__ + "static/media/signup-step.724169378317af4db579461137a954ee.svg";
export { ForwardRef as ReactComponent };